import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { EmergencyScenarioStatus } from '../../graphql/api/generated';
import { PermissionKey_enum } from '../../graphql/hasura/generated';
import { ModelsContext } from '../../hooks/providers';
import { authentication } from '../../stores';
import { TableActions } from '../TableActions/TableActions';

export const EmergencyScenarioAlertTitle: React.FC<{ emergencyScenario: any }> = (props) => {
  const emergencyScenario = props.emergencyScenario || {};
  const { emergencyScenarioId, name, status, property = {} } = emergencyScenario;

  // @TODO: A circular dep prevents us from importing toggleStatusAction
  const { getModel } = useContext(ModelsContext);
  const EmergencyScenarioModel = getModel('EmergencyScenario');
  const actions = EmergencyScenarioModel.actions.defaultActions;

  const canMonitor = authentication
    .hasPermission(PermissionKey_enum.EmergencyScenario_Read);

  const canManage = authentication
    .hasPermission(PermissionKey_enum.EmergencyScenario_Manage);

  // @TODO: A circular dep prevents us from importing EmergencyScenarioModel
  const emergencyScenarioLink = canMonitor
    ? `/emergency-scenarios/details/${emergencyScenarioId}`
    : null;

  // @TODO: A circular dep prevents us from importing PropertyModel
  const propertyLink = `/properties/details/${property.propertyId}`;

  const severityText = status === EmergencyScenarioStatus.ACTIVE
    ? <strong>EMERGENCY: </strong>
    : <strong>TEST MODE: </strong>;

  const statusText = status === EmergencyScenarioStatus.ACTIVE ? 'active' : 'being tested';

  if (emergencyScenarioLink) {
    return (
      <>
        {severityText}Emergency scenario{' '}
        <Link to={emergencyScenarioLink}>{name}</Link> is {statusText} at{' '}
        <span style={{ whiteSpace: 'nowrap' }}>{property.name}</span>
        {canManage && (
          <>
            <span style={{ marginLeft: '10px', marginRight: '10px' }}>|</span>
            <TableActions
              row={emergencyScenario}
              actions={actions}
              style={{ display: 'inline' }}
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {severityText}Emergency scenario <strong>{name}</strong> is {statusText} at{' '}
      <Link to={propertyLink} style={{ whiteSpace: 'nowrap' }}>
        {property.name}
      </Link>
    </>
  );
}
